import { Box, Skeleton } from '@mui/material';
import { SxProps, Theme } from '@mui/material/styles';
import { useAuthenticatedImage } from '../hooks/useAuthenticatedImage';

interface AuthenticatedImageProps {
    url: string | null | undefined;
    alt: string;
    sx: SxProps<Theme>;
}

const AuthenticatedImage: React.FC<AuthenticatedImageProps> = ({
    url,
    alt,
    sx,
}) => {
    const { src, isLoading } = useAuthenticatedImage(url);

    if (isLoading) {
        return (
            <Box sx={sx}>
                <Skeleton variant="rectangular" width="100%" height="100%" />
            </Box>
        );
    }

    if (!src) {
        return <Box sx={sx} />;
    }

    return (
        <Box
            component="img"
            src={src}
            alt={alt}
            loading="lazy"
            sx={sx}
        />
    );
};

export default AuthenticatedImage;
